var render = function render(){
  var _vm$bannerToDelete;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen bg-gray-100"
  }, [_c('div', {
    staticClass: "mx-auto p-6"
  }, [_c('div', {
    staticClass: "flex justify-between items-end mb-6 mdmax:flex-col mdmax:items-stretch gap-4"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:w-full"
  }, [_c('div', {
    staticClass: "max-w-lg"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(" Pencarian ")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari banner..."
    },
    on: {
      "enter": _vm.onSearch
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])]), _c('div', {
    staticClass: "flex mdmax:w-full"
  }, [_c('button', {
    staticClass: "px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 font-medium",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/banner/create');
      }
    }
  }, [_vm._v(" + Tambah Banner ")])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.tableData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('span', {
          staticClass: "flex items-center gap-3"
        }, [_c('button', {
          staticClass: "text-neutral-500 hover:text-primary-500",
          attrs: {
            "title": "Edit"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/banner/edit/${entry.id}`);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "width": "18",
            "height": "18"
          }
        })], 1), _c('button', {
          staticClass: "text-neutral-500 hover:text-red-500",
          attrs: {
            "title": "Delete"
          },
          on: {
            "click": function ($event) {
              return _vm.onDelete(entry);
            }
          }
        }, [_c('Trash', {
          attrs: {
            "width": "18",
            "height": "18"
          }
        })], 1)]) : column.field === 'RowNumber' ? _c('span', {
          staticClass: "font-medium"
        }, [_vm._v(" " + _vm._s(entry.RowNumber) + " ")]) : column.field === 'imageURL' ? _c('span', [entry.imageURL ? _c('img', {
          staticClass: "w-20 h-12 object-cover rounded",
          attrs: {
            "src": entry.imageURL,
            "alt": "Banner Image"
          }
        }) : _vm._e()]) : column.field === 'isActive' ? _c('span', [_c('span', {
          staticClass: "px-2 py-1 rounded text-xs font-medium",
          class: _vm.statusClass(entry.isActive)
        }, [_vm._v(" " + _vm._s(entry.isActive ? "Active" : "Inactive") + " ")])]) : _c('span', {
          staticClass: "text-sm text-gray-700"
        }, [_vm._v(" " + _vm._s(entry[column.field]) + " ")])];
      }
    }])
  }), _vm.tableData.length > 0 ? _c('div', {
    staticClass: "mt-6 mb-6 flex justify-between items-center mdmax:flex-col mdmax:items-start gap-4"
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "text-sm font-medium text-neutral-500"
  }, [_vm._v(" Menampilkan " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " dari " + _vm._s(_vm.totalRecords) + " ")]) : _vm._e(), _c('Pagination', {
    attrs: {
      "currentPage": _vm.page,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.limit
    },
    on: {
      "onPageChange": _vm.changePage
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.deleteModalVisible,
      "width": "400px"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "text-center",
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('h3', {
    staticClass: "text-lg font-bold text-neutral-800 mb-2"
  }, [_vm._v("Hapus Banner")]), _c('p', {
    staticClass: "text-neutral-600 mb-6"
  }, [_vm._v(" Apakah Anda yakin ingin menghapus banner "), _c('strong', [_vm._v(_vm._s((_vm$bannerToDelete = _vm.bannerToDelete) === null || _vm$bannerToDelete === void 0 ? void 0 : _vm$bannerToDelete.name))]), _vm._v("? ")]), _c('div', {
    staticClass: "flex justify-center gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium",
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 font-medium",
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v(" Hapus ")])])])])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }